import React, { Component } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

import './EventItem.css';



export default class EventItem extends Component {
  render() {
    var myStyle = {
      borderLeft: '3px solid ' + this.props.event.color,
    }

    return (
      <div className="mobile-event-item d-flex fadeAnimation">
        <div className="mobile-event-item__right d-flex">
          <FormControlLabel
            control={
              <Checkbox
                icon={<RadioButtonUncheckedIcon
                  style={{ color: this.props.event.color }} />}
                checkedIcon={<CheckCircleOutlineIcon
                  style={{ color: this.props.event.color }} />}
                name={this.props.event.title} onChange={(e) => { e.preventDefault(); this.props.addDone(this.props.event, this.props.event.id) }} />
            }
          />
          <div className="mobile-event-item__right--text d-flex flex-column">
            <h2>{this.props.event.title}</h2>
            <div>{this.props.event.description}</div>
          </div>
        </div>
        <div className="mobile-event-item__left d-flex" style={myStyle}>
          <div className="mt-3">{this.props.event.time}</div>
        </div>
      </div>
    );
  }
}